//
//
//
//
//
//
//
//
//
//
//


import Flash from '~/components/Flash.vue';
import axios from 'axios';
export default {
    components: {
        Flash: Flash
    },
    data: function data() {
        return {
            name: 'My APP',
            description: 'Description ',
            isAuth: false,
            websiteLogo: '',
            loggedUser: {},
            loading: false,
            paymentMethod: '',
            showDirectoryLink: false,
            isHawwiyahDomain: false,
            newLoading: false,
            domain: ''
        };
    },
    head: function head() {
        var links = [];
        if (global.getFaviconPath()) {
            links.push({ rel: 'icon', href: global.getFaviconPath() });
        }
        return {
            //{rel: 'icon',  type: "image/png", href: '/favicon.png'}
            link: links,
            script: [{ src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyABRNVefWrqOTk-iAz8p0Arn96j-hMFB-I' }, { src: 'https://api.paymentwall.com/brick/build/brick-default.1.5.0.min.js' }],
            titleTemplate: this.$root.trans(global.websiteSettings.extra_info.title)
        };
    },
    created: function created() {
        var _this = this;

        if (process.browser) {
            this.domain = document.location.hostname.replace('.com', '').replace('www.', '');
        }
        if (process.client) {
            this.isAuth = this.$auth.isAuthenticated();
            this.refreshLoggedUser();

            if (window.location.host.match(/hawiyyah.com/i) && !global.showErrorPage) {
                this.showDirectoryLink = true;
            }

            if (window.location.host.match(/hawwiyah.com/i)) {
                this.isHawwiyahDomain = true;
            }
        }

        global.getPaymentMethodId().then(function (value) {
            _this.paymentMethod = value;
        });
        //$("footer").css({postion:'absolute'});
    },
    mounted: function mounted() {
        if (global.getLogoPath()) {
            this.websiteLogo = global.getLogoPath();
        }
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang ? this.$root._route.params.lang : 'en';
        }
    },
    methods: {
        refreshLoggedUser: function refreshLoggedUser() {
            this.$auth.getUser(function (user) {
                this.loggedUser = user;
            }.bind(this));
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./layouts/assistant.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./layouts/assistant.vue
// module chunks = 20